/// <amd-module name="TFS/Admin/Groups/Common/Util/LinkPropsHelper" />
import { effects } from "redux-saga";
import { AdminHubViewKeys, QueryParams, Routes } from "TFS/Admin/Common/Constants/Constants";
import { IPermissionPage } from "TFS/Admin/Groups/Common/Constants";
import { GroupsTelemetryLogger } from "TFS/Admin/Groups/Common/Util/GroupsTelemetryLogger";
import { ITfsPageService } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssLocationService } from "VSS/Platform/Location";

function* getRouteId(page: IPermissionPage): any {
    if (IPermissionPage.Project == page || IPermissionPage.Teams == page) {
        return Routes.ProjectSettingsRouteId;
    }

    return Routes.OrganisationSettingsRouteId;
}

function* getRouteParameters(page: IPermissionPage, projectName?: string): any {
    const routeValues: { [key: string]: string } = {};

    if (page != IPermissionPage.Organization) {
        if (projectName) {
            routeValues[QueryParams.Project] = projectName;

            if (page == IPermissionPage.Teams) {
                routeValues[QueryParams.AdminPivot] = AdminHubViewKeys.TeamGroups;
            } else if (page == IPermissionPage.Project) {
                routeValues[QueryParams.AdminPivot] = AdminHubViewKeys.ProjectGroups;
            }

            return routeValues;
        }
        // If ProjectData is null - we still want the navigation to work
    }

    routeValues[QueryParams.AdminPivot] = AdminHubViewKeys.OrganisationGroups;

    return routeValues;
}

export function getPermissionsPage(isTeamsPage?: boolean, isProjectScope?: boolean): IPermissionPage {
    return isTeamsPage ? IPermissionPage.Teams : isProjectScope ? IPermissionPage.Project : IPermissionPage.Organization;
}

export function* getProjectName(pageContext: IVssPageContext, telemetryLogger: GroupsTelemetryLogger): any {
    try {
        const tfsPageService: ITfsPageService = (yield effects.call([pageContext, pageContext.getService], "ITfsPageService")) as any;
        const pageData = (yield effects.call([tfsPageService, tfsPageService.getData])) as any;

        return pageData && pageData.project ? pageData.project.name : undefined;
    } catch (error) {
        yield effects.call(telemetryLogger.captureError, error.message || error);
        return undefined;
    }
}

export function* getUrlForGraphSubject(
    descriptor: string,
    permissionPage: IPermissionPage,
    locationService: IVssLocationService,
    telemetryLogger: GroupsTelemetryLogger,
    projectName?: string
): any {
    try {
        const routeValues: { [key: string]: string } = (yield effects.call(getRouteParameters, permissionPage, projectName)) as any;
        routeValues[QueryParams.SubjectDescriptor] = descriptor;

        const routeId: string = (yield effects.call(getRouteId, permissionPage)) as any;

        return yield effects.call([locationService, locationService.routeUrl], routeId, routeValues);
    } catch (error) {
        yield effects.call(telemetryLogger.captureError, error.message || error);
        return "";
    }
}
